<style>
    #header {
        /*padding: 16px 16px;*/
        /*padding: 12px 12px;*/
        background-color: #F7F8F9;
        min-height: var(--header-height);
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 1040;
        color: var(--text-subtle);
    }
    [data-theme="dark"] #header{
        background-color: var(--header-background);
        color: var(--text-color);
    }
    #header .header-nav-menu{
        color: #172B4D;
        font-weight: 500;
        padding: 0px 16px 0px 16px;
    }
    [data-theme="dark"] #header .header-nav-menu{
        color: var(--text-color);
    }
    #header .header-nav-menu .dropdown:hover .dropdown-menu{
        /*display: block;*/
    }
    #header .header-nav-menu .dropdown-menu::-webkit-scrollbar-thumb {
        border: 6px solid var(--card-background);    
    }
    #header .header-nav-menu .dropdown-menu::-webkit-scrollbar-track {
        background: var(--card-background);
    }
    #header .header-nav-menu ul{
        flex-wrap: nowrap;
        /*overflow: auto;*/
    }
    #header .header-nav-menu .swiper-container {
        width: 100%;
        height: 100%;
        position: relative;
        overflow: visible; 
        padding: 0px 44px;
    }
    #header .header-nav-menu .swiper-nav-wrapper-prev,
    #header .header-nav-menu .swiper-nav-wrapper-next{
        background: #F7F8F9 !important;
        width: 56px;
        opacity: 1;
    }
    [data-theme="dark"] #header .header-nav-menu .swiper-nav-wrapper-prev,
    [data-theme="dark"] #header .header-nav-menu .swiper-nav-wrapper-next{
        background: var(--header-background) !important;
    }
    #header .header-nav-menu .swiper-wrapper.auto .swiper-slide{
        margin-right: 20px;
    }
    #header .header-nav-menu-list{
        
    }
    #header .header-nav-menu-list-item{
        
    }
    #header .header-nav-menu a{
        display: inline-block;
        padding: 12px 0px;
        outline: none;
    }
    #header .header-nav-menu .dropdown-menu{
        padding: 32px;
        border: none;
        border-radius: 14px;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);
        min-width: 258px;
        margin-top: 0px;
        margin-right: 20px;
        max-height: 360px;
        overflow: auto;
    }
    #header .header-nav-menu .dropdown-item{
        color: #172B4D;
        font-size: 12px;
        font-weight: 500;
        padding: 4px 0px;
        margin-bottom: 10px;
    }
    [data-theme="dark"] #header .header-nav-menu .dropdown-item{
        color: var(--text-color);
    }
    #header .header-nav-menu .dropdown-item:last-child{
        margin-bottom: 0px;
    }
    .header-wrapper {
       /* max-width: 1100px;*/
        margin: 0 auto;
        display: flex;
        align-items: center;
        height: 100%;
        padding: 12px 12px;
        min-height: 61px;
    }

    /* Old Styles */
    :root{
        /*--header-height: 70px;*/
        --header-height: 100px;
        --header-text-color: white;
    }
    .grecaptcha-badge {
        visibility: hidden;
    }
    .recaptcha-info{
        line-height: 16px;
        display: inline-block;
        margin-top: 10px;
    }
    #main-wrapper{
        padding-top: var(--header-height);
    }
    #header .divider-v{
        height: 30px;
        width: 1px;
        background-color: rgb(255 255 255 / 50%);
        margin: 0 20px;
    }

    #header .header-search{
        height: 100%;
        background: var(--card-background);
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
    }
    #header .header-search label {
        font-size: 12px;
        font-weight: 700;
    }
    #header .header-search a {
        color: inherit;
    }
    #header .header-search .header-search-bar{
        height: 100%;
        max-width: 1000px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        padding: 0 10px;
    }
    #header .header-search ul{
        list-style: none;
        padding-left: 10px;
    }
    #header .header-search ul li{
        margin: 10px 0;
    }
    #header .header-search input{
        border: none;
        box-shadow: none;
    }
    #header .header-search img{
        width: 32px;
        height: 32px;
        object-fit: cover;
        border-radius: 50%;
        margin-right: 4px;
    }
    #header .header-search .search-suggestions{
        background-color: var(--card-background);
        height: auto;
        padding: 30px 30px;
        max-width: 1000px;
        margin: 0 auto;
        font-size: 16px;
        max-height: 93vh;
        overflow: auto;
    }
    #header .border-1{
        border-left: 1px solid white;
    }
    #menuModal .modal-dialog{
        margin: 0;
        min-width: 260px;
        max-width: 280px;
        position: absolute;
        top: calc(var(--header-height) + 6px);
        right: 10px;
    }
    #menuModal .modal-content{
        border-radius: 5px;
        border: none;
        padding: 12px;
    }
    [data-theme="light"] #menuModal .modal-content{
        box-shadow: 0px 0px 7px 3px rgba(121, 130, 145, 0.30);
    }
    #menuModal .modal-body {
        padding: 0px;
    }
    #menuModal .menu-item{
        display: flex;
        align-items: center;
        padding: 8px;
        border-radius: 5px;
        color: var(--text-color);
        min-height: 48px;
    }
    #menuModal .menu-item:hover {
        background-color: var(--border-color-1);
    }
    #menuModal .menu-item > i,
    #menuModal .menu-icon {
        font-size: 20px;
        margin-right: 16px;
        width: 32px;
    }
    
    #menuModal .menu-item.disabled {
        opacity: 0.3;
        pointer-events: none;
    }

    #menuModal .menu-item.danger:hover {
        background-color: var(--danger-subtle);
    }
    #menuModal .btn-icon{
        height: 32px !important;
        width: 32px !important;
    }
    .search-overlay {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }

    @media(max-width: 992px){
        #header .border-1{
            border: none;
        }
    }

    @media (max-width: 768px) {
/*        #header .header-wrapper{
            padding: 16px 8px;
        }*/
    }
    .input-icon-container{
        position: relative;
        width: 100%;
        max-width: 705px;
        height: 37px;
    }
    .input-icon-container > .input-icon{
        position: absolute;
        top: 4px;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        /*right: 5px;*/
        /* color: var(--text-subtle); */
       /* background: var(--primary);*/
        /*color: white;*/
        color: var(--text-subtle);
        border-radius: 50%;
        width: 29px;
        text-align: center;
        height: 29px;
        padding-left: 2px;
    }
    .input-icon-container > .input-loading{
        position: absolute;
        top: 8px;
        left: 6px;
        color: var(--primary);
    }
    .input-icon-container input.form-control {
        padding-left: 40px;
        padding-right: 38px;
/*        background: white;
        color: #798291;*/
        border-radius: 19px;
      /*  box-shadow: 0px 0px 8px 3px rgba(30, 31, 36, 0.30);*/
      /*  box-shadow: 0px 0px 6px 1px rgba(32, 33, 36, 0.25);*/
        box-shadow: var(--card-box-shadow);
    }
    .c-indicator{
        display: inline-block;
        height: 9px;
        width: 9px;
        border-radius: 50%;
        cursor: pointer;
        margin: 0px 4px;
        background-color: var(--text-subtle);
    }
    .c-indicator.active{
        background-color: var(--primary);
    }
    .swiper-nav-wrapper-prev {
        background: none !important;
        left: -16px;
        font-size: 16px;
    }
    .swiper-nav-wrapper-next {
        background: none !important;
        right: -16px;
        font-size: 16px;
    }
    .swiper-button-prev:after,
    .swiper-button-next:after{
        content: '' !important;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    #search1 {
        margin: 0 auto;
        border: none; /* <-- This thing here */
        border:solid 1px #ccc;
        border-radius: 19px;
    }
   .search-header{
        padding-left: 20px;
        padding-right: 38px;
/*        background: white;
        color: #798291;*/
        border-radius: 19px;
        height: 37px;
    }
    [data-theme="light"] .search-header{
        background: white;
    }

    .header-wrapper a.active{
        border-bottom: 1px solid var(--primary);
    }

    
    @media (max-width: 576px) {

    }
</style>

<template>

    <div id="header-container">
        <div id="header">
            <div class="header-wrapper">
                <div class="w-100 row row-sm no-gutters-mobil justify-content-between align-items-center flex-nowrap">
                    <div class="col-auto">
                        <a class="mr-2" href="/" title="ReachDog Home">
                            <img class="logo" src="/img/reach_dog/Reachdog_primary_fog_small.png" height="26" width="104" alt="ReachDog logo" title="ReachDog logo">
                        </a>
                    </div>
                    <div class="col">
                        <div class="d-flex align-items-center justify-content-center">
                            <search class="input-icon-container d-none d-md-block show-header-home">
                                <div class="input-loading"  v-show="loading.search">
                                    <i class="fas fa-spin fa-spinner fa-fw"></i>
                                </div>
                                <div class="input-icon">
                                    <i class="fas fa-search fa-fw pl-2"></i>
                                </div>
                                <input id="headerSearchInput" type="text" name="search" class="form-control search-header" placeholder="Search for products, brands, or shops" v-model="search" @input="debouncedSearch"  @keyup.enter="redirectToSearch">
                            </search>
                        </div>
                    </div>
                    <div class="col-auto">
                        <nav class="d-flex align-items-center mx-2">

                            <div class="mx-2 p-1 d-block d-md-none pointer" title="Show Search Overlay"  @click="showSearch" @mouseover="initSearchSuggestions">
                                <i class="fas fa-search fs-20 icon-color"></i>
                            </div>

                            <template v-if="user">
                                <div class="mx-2">
                                    <watchlist-dropdown></watchlist-dropdown>
                                </div>
                                <div class="mx-2">
                                    <a class="px-1" href="/lists" title="My Lists">
                                        <i class="fas fa-fw fs-20 fa-bookmark icon-color"></i>
                                    </a>
                                </div>
                                <div class="mx-2">
                                    <div class="row row-sm align-items-center pointer flex-nowrap" id="dropdownMenuButton" @click="showMenu">
                                        <div class="col-auto">
                                            <user-image :user="user" :height="32" :width="32"></user-image>
                                        </div>
                                        <div class="col-auto">
                                            <i class="fas fa-fw fa-chevron-down"></i>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <a href="/how-it-works" class="text-color hover-primary mx-2 d-none d-md-block" title="How It Works" :class="{active: route_name === 'how-it-works'}">How It Works</a>
                                <a href="/business" class="text-color hover-primary mx-2 d-none d-md-block" title="ReachDog For Business" :class="{active: route_name === 'business'}">For Business</a>
                                <button class="btn btn-sm mx-2 mr-4 d-none d-md-block" title="Toggle Theme" aria-label="Toggle Theme" @click="toggleTheme">
                                    <i class="fas fa-adjust"></i>
                                </button>
                                <button v-if="show_modal" type="button" class="d-none d-md-block btn text-primary rounded-pill btn-sm mx-1" @click="showLoginModal">Log In</button>
                                <button v-if="show_modal" type="button" class="d-none d-md-block btn btn-primary rounded-pill btn-sm mx-1" @click="showRegisterModal">Register</button>
                                <a v-if="!show_modal" href="/login" class="d-none d-md-block btn font-weight-normal" title="Sign In">Log In</a>
                                <a v-if="!show_modal" href="/signup" class="d-none d-md-block btn text-primary font-weight-normal" title="Register">Register</a>

                                <div class="mx-2 d-md-none">
                                    <div class="pointer" id="dropdownMenuButton" @click="showMenu">
                                        <span class=""><i class="fas fa-bars fa-2x"></i></span>
                                    </div>
                                </div>
                            </template>
                        </nav>
                    </div>
                </div>

            </div>
            <div class="header-search" v-if="show_search">
                <div class="header-search-bar">
                    <i class="fas fa-spin fa-spinner" v-if="loading.suggestions"></i>
                    <i class="fas fa-fw fa-search" v-else></i>
                    <input id="headerSearchInput" type="text" autocomplete="off" class="form-control" v-model="search" @input="debouncedSearch" @keyup.enter="redirectToSearch">
                    <button class="btn" @click="hideSearch" aria-label="Hide Search Overlay">
                        <i class="fas fa-fw fa-times"></i>
                    </button>
                </div>
            </div>
            <nav class="header-nav-menu" v-if="categories && categories.length">
                <div class="header-nav-menu-list list-unstyled mb-0">
                    <carousel :options="carousel_options" prev="1" next="1">
                        <div class="swiper-slide" v-for="category in categories">
                            <div class="dropdown header-nav-menu-list-item" >
                                <a class="text-reset" :href="category.url" data-toggle="dropdown" >{{category.name}}</a>
                                <div class="dropdown-menu" v-if="category.subcategories" >
                                    <a class="dropdown-item" :href="subcategory.url" v-for="subcategory in category.subcategories">{{subcategory.name}}</a>
                                </div>
                            </div>
                        </div>
                    </carousel>
                </div>
            </nav>
        </div>
        
        <div class="modal" id="authModal">
            <div id="g_id_onload"
                data-client_id="221381283627-1lbo4a8ng307vache49emvv8l5dblge3.apps.googleusercontent.com"
                data-context="signup"
                data-ux_mode="popup"
                :data-login_uri="google_login_uri"
                data-auto_prompt="false">
            </div>
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header pb-0">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="fas fa-times fa-sm"></i>
                        </button>
                    </div>
                    <div class="modal-body px-4 pt-0" v-show="is_login">
                        <h3 class="text-center mb-3">Log In</h3>
                        <div style="width: 100%; height:44px">
                            <div class="g_id_signin"
                                data-type="standard"
                                data-shape="rectangular"
                                data-theme="outline"
                                data-text="signin_with"
                                data-size="large"
                                data-logo_alignment="center"
                                data-width="200">
                            </div>
                        </div>
                        <div class="text-divider"><div>or</div></div>

                        <form id="loginForm" method="POST" action="/login" data-vv-scope="login">
                            <template v-html="csrf_field"></template>
                            <input type="hidden" name="redirect" v-model="redirect">
                            <div class="form-group form-outline">
                                <input type="email" name="email" class="form-control mb-1" required v-model="email" v-validate="'required|email'" data-vv-as="Email" placeholder=" ">
                                <label>Email</label>
                                <small class="text-danger" v-show="errors.has('login.email')">{{ errors.first('login.email') }}</small>
                            </div>
                            <div class="form-group form-outline">
                                <input type="password" class="form-control mb-1" name="password" required v-model="password" v-validate="'required|min:6'" data-vv-as="Password" ref="password" placeholder=" ">
                                <label>Password</label>
                                <small class="text-danger" v-show="errors.has('login.password')">{{ errors.first('login.password') }}</small>
                            </div>
                            <div class="form-group form-outline">
                                <a href="/forgot-password">Forgot your password?</a>
                            </div>
                            <button type="submit" class="btn btn-primary rounded-pill w-100" @click="submitForm($event, 'login')" :disabled="loading.submit">
                                <i class="fas fa-spin fa-spinner mr-1" v-if="loading.submit"></i>
                                Log In
                            </button>
                        </form>
                    </div>
                    <div class="modal-body" v-show="!is_login">
                        <h3 class="text-center mb-3">Create an account</h3>
                        <div style="width: 100%; height:44px">

                            <div class="g_id_signin"
                                data-type="standard"
                                data-shape="rectangular"
                                data-theme="outline"
                                data-text="signup_with"
                                data-size="large"
                                data-logo_alignment="center"
                                data-width="200">
                            </div>
                        </div>
                        <div class="text-divider"><div>or</div></div>
                        <form id="signupForm" method="POST" action="/signup" data-vv-scope="signup">
                            <template v-html="csrf_field"></template>
                            <input type="hidden" name="redirect" v-model="redirect">
                            <input type="hidden" name="sponsor_uuid" v-model="sponsor_uuid" v-if="sponsor_uuid">
                            <div class="form-group form-outline">
                                <input type="text" class="form-control mb-1" name="full_name" required v-model="full_name" v-validate="'required'" data-vv-as="Name" placeholder=" ">
                                <label>Name</label>
                                <small class="text-danger" v-show="errors.has('signup.full_name')">{{ errors.first('signup.full_name') }}</small>
                            </div>
                            <div class="form-group form-outline">
                                <input type="email" class="form-control mb-1" name="email" required v-model="email" v-validate="'required|email'" data-vv-as="Email" placeholder=" ">
                                <label>Email</label>
                                <small class="text-danger" v-show="errors.has('signup.email')">{{ errors.first('signup.email') }}</small>
                            </div>
                            <div class="form-group form-outline">
                                <input type="password" class="form-control mb-1" name="password" required v-model="password" v-validate="'required|min:6'" data-vv-as="Password" ref="password" placeholder=" ">
                                <label>Password</label>
                                <small class="text-danger" v-show="errors.has('signup.password')">{{ errors.first('signup.password') }}</small>
                            </div>
                            <div class="form-group form-outline">
                                <input type="password" class="form-control mb-1" name="password_confirmation" required v-model="password_confirmation" v-validate="'required|confirmed:password'" data-vv-as="Password Confirmation" placeholder=" ">
                                <label>Password Confirmation</label>
                                <small class="text-danger" v-show="errors.has('signup.password_confirmation')">{{ errors.first('signup.password_confirmation') }}</small>
                            </div>
                            <div class="form-group custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" name="terms" id="check-tos" required v-model="terms" v-validate data-vv-as="Terms of Service">
                                <label class="custom-control-label mb-1" for="check-tos">I agree to the <a href="/tos" target="_blank" title="Terms of Service">Terms of Service</a></label>
                                <small class="text-danger d-block" v-show="errors.has('signup.terms')">{{ errors.first('signup.terms') }}</small>
                            </div>
                            <div class="form-group form-outline">
                                <div id="recaptcha1" style="min-height: 78px"></div>
                                <input type="hidden" name="recaptcha_v3_token" v-model="recaptcha_v3_token">
                            </div>

                            <button class="btn btn-primary rounded-pill w-100" @click="submitForm($event, 'signup')" :disabled="loading.submit">
                                <i class="fas fa-spin fa-spinner mr-1" v-if="loading.submit"></i>
                                Register
                            </button>
                            <small class="recaptcha-info">
                                This site is protected by reCAPTCHA and the Google
                                <a href="https://policies.google.com/privacy" title="Google Privacy Policy">Privacy Policy</a> and
                                <a href="https://policies.google.com/terms" title="Google Terms of Service">Terms of Service</a> apply.
                            </small>
                        </form>
                    </div>
                    <div class="modal-footer text-center">
                        <span v-if="is_login">Don't have an account? <span class="text-primary pointer" @click="showRegisterModal" title="Create an account">Create one for free!</span></span>
                        <span v-else>Already have an account? <span class="text-primary pointer" @click="showLoginModal" title="Log in">Log in</span></span>
                    </div>
                </div>
            </div>
        </div>


        <div class="modal" id="menuModal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <nav class="modal-body">
                       
                        <template v-if="user">
                            
                            <div class="menu-item">
                                <div class="d-flex align-items-center">
                                    <user-image class="mr-2" :user="user" :height="32" :width="32"></user-image>
                                    <div>
                                        <div>{{user.full_name || user.name}}</div>
                                        <small>{{user.email}}</small>
                                    </div>
                                </div>
                            </div>

                            <template v-if="user.user_type === 'business'">
                                <a class="menu-item" href="/business-hub" title="Business Hub">
                                    <i class="fas fa-store fa-fw fs-20"></i>
                                    Business Hub
                                </a>
                                <a class="menu-item" href="/discover" title="Discover">
                                    <i class="fas fa-compass fa-fw fs-20"></i>
                                    Discover
                                </a>
                                <a class="menu-item" href="/pages" title="Pages">
                                    <i class="fas fa-copy fa-fw fs-20"></i>
                                    Pages
                                </a>
                            </template>
                            <template v-else>
                                <a class="menu-item" href="/business" title="Switch to Business">
                                    <i class="fas fa-store fa-fw fs-20"></i>
                                    Switch to Business
                                </a>
                            </template>

                            <hr class="my-1">

                            <a class="menu-item" href="/settings" title="Settings">
                                <i class="fas fa-fw fa-cog"></i> Settings & Privacy
                            </a>

                            <div class="menu-item pointer" @click="toggleTheme">
                                <i class="fas fa-adjust fa-fw fs-20"></i>
                                <span>Change to: 
                                    <strong v-if="current_theme === 'dark'">Light Mode</strong>
                                    <strong v-else>Dark Mode</strong>
                                </span>
                            </div>

                            <a class="menu-item" href="/post/create/basic" title="Create a post" hidden>
                                <i class="fas fa-fw fa-plus"></i> Create a post
                            </a>

                            <a class="menu-item" href="/lists" title="My Lists" hidden>
                                <i class="fas fa-fw fa-list"></i> My Lists
                            </a>

                            <a class="menu-item" href="/settings#invitations" title="Invitations" hidden>
                                <i class="fas fa-fw fa-envelope-open"></i> Invitations 
                                <span v-if="invitation_count"> ({{invitation_count}})</span>
                            </a>

                            <hr class="my-2">

                            <a class="menu-item pointer" href="/contact" title="Contact Support">
                                <div class="menu-icon bg-border-color-1 btn-icon rounded-circle">
                                    <i class="fas fa-fw fa-envelope fs-16"></i>
                                </div>
                                <span class="">Contact Support</span>
                            </a>

                            <a class="menu-item danger pointer" :href="'/logout?redirect=' + redirect" title="Log Out">
                                <div class="menu-icon btn-danger-subtle btn-icon rounded-circle">
                                    <i class="fas fa-fw fa-sign-out-alt fs-16"></i>
                                </div>
                                <span class="text-danger">Log Out</span>
                            </a>
                            
                        </template>
                        
                         
                        <template v-else>
                            <div class="menu-item pointer" @click="toggleTheme">
                                <i class="fas fa-adjust fa-fw fs-20"></i>
                                <span>Change to: 
                                    <strong v-if="current_theme === 'dark'">Light Mode</strong>
                                    <strong v-else>Dark Mode</strong>
                                </span>
                            </div>

                            <hr class="my-1">
                            
                            <a class="d-block d-md-none menu-item pointer" href="/contact" title="Contact Support">
                                <div class="menu-icon bg-border-color-1 btn-icon rounded-circle">
                                    <i class="fas fa-fw fa-list fs-16"></i>
                                </div>
                                <span class="">How It Works</span>
                            </a>

                            <a class="d-block d-md-none menu-item pointer" href="/business" title="ReachDog For Business">
                                <div class="menu-icon bg-border-color-1 btn-icon rounded-circle">
                                    <i class="fas fa-fw fa-store fs-16"></i>
                                </div>
                                <span class="">For Business</span>
                            </a>
                            
                            <div class="mt-3">
                                <button class="btn btn-primary w-100 rounded-pill mb-2" @click="showRegisterModal">Register</button>
                                <button class="btn btn-outline-primary w-100 rounded-pill" @click="showLoginModal">Log In</button>
                            </div>
                        </template>
                        
                        <div class="text-center text-subtle mt-3">
                            <a class="text-reset hover-primary" href="/privacy" target="_blank" title="Privacy Policy">Privacy</a>
                            •
                            <a class="text-reset hover-primary" href="/tos" target="_blank" title="Terms of Service">Terms</a>                            
                            •
                            Reach.Dog © {{current_year}}
                        </div>
                        
                    </nav>
                        
                </div>
            </div>
        </div>

        <div id="emailVerificationModal" class="modal fade p-0" v-if="user">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header pb-0">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="fas fa-times fa-sm"></i>
                        </button>
                    </div>
                    <div class="modal-body text-center">
                        <email-verification></email-verification>
                    </div>
                    <div class="modal-footer"></div>
                </div>
            </div>
        </div>
        
        <save-group-modal></save-group-modal>
    </div>

</template>

<script>
    import { Validator, install as VeeValidate } from 'vee-validate/dist/vee-validate.minimal.esm.js';
    import { required, min, email, confirmed } from 'vee-validate/dist/rules.esm.js';
    import veeEn from 'vee-validate/dist/locale/en';
    Validator.extend('required', required);
    Validator.extend('min', min);
    Validator.extend('email', email);
    Validator.extend('confirmed', confirmed);

    Validator.localize('en', veeEn);

    Vue.use(VeeValidate);

    var debounce = require('lodash.debounce');

    import userImage from '../components/misc/userImage';
    import emailVerification from '../components/email/emailVerification';
    import saveGroupModal from '../components/group/saveGroupModal';
    import watchlistDropdown from '../components/watchlist/watchlistDropdown';
    import carousel from '../components/misc/carousel';

    export default {
        name: 'Header',
        components: {
            userImage,
            emailVerification,
            saveGroupModal,
            watchlistDropdown,
            carousel
        },
        data() {
            return {
                imgUrlRallyNavLogo: window.imgUrlRallyNavLogo,
                loading: {
                    submit: false,
                    suggestions: false,
                    default_suggestions: false,
                    invitations: false
                },
                is_login: false,
                full_name: '',
                email: '',
                password: '',
                password_confirmation: '',
                terms: false,
                redirect: window.location.href,
                loaded_recaptcha_script: false,
                recaptcha_token: '',
                recaptcha_v3_token: '',
                show_search: false,
                search: '',
                profiles: [],
                hashtags: [],
                top_hashtags: [],
                recent_searches: [],
                loaded_defaults: false,
                show_modal: true,
                showHeaderMovil: false,
                showHeaderWeb: true,
                showHeaderHome: true,
                loaded_gsi_script: false,
                sponsor_uuid: null,
                user: null,
                invitation_count: null,
                current_theme: 'light',
                carousel_options: {
                    direction: 'horizontal',
                    slidesPerView: 'auto',
                    slidesPerGroup: 3,
                    speed: 800,
                    spaceBetween: 20,
                    loop: false,
                    freeMode: false,
                    navigation: {}
                },
                categories: []
            }
        },
        watch: {

        },
        computed: {
            current_year: function(){
                if(typeof current_year === 'number'){
                    return current_year;
                }
                return moment().year();
            },
            login_form_is_valid: function () {
                if (!this.email || !this.password) {
                    return false;
                }

                return true;
            },
            signup_form_is_valid: function () {
                if (!this.full_name || !this.email || !this.password || !this.password_confirmation || !this.terms) {
                    return false;
                }
                if (this.password !== this.password_confirmation) {
                    return false;
                }

                return true;
            },
            google_login_uri: function(){
                return window.location.origin + '/google/callback';
            },
//            route_name:function(){
//                console.log(window.route_name);
//                return window.route_name;
//            }
        },
        created: function () {
            if (typeof auth_user === 'object') {
                this.user = auth_user;
            }
            this.categories = window.header_categories;
            
            var params = new URLSearchParams(window.location.search);
            if(window.route_name === 'search' && params.has('q')){
                var query = params.get('q');
                if(query){
                    query = query.replaceAll('-', ' '); //remove hyphens
                }
                this.search = query;
            }
        },
        mounted: function () {
            var self = this;
            this.current_theme = document.documentElement.getAttribute('data-theme') || 'light';
            
            this.initIntersection(document.getElementById('header'), this.init);

            window.bus.$on('show_login_form', this.showLoginModal);
            window.bus.$on('show_signup_form', this.showRegisterModal);
            window.bus.$on('update_profile_image', this.updateProfileImage);
            window.bus.$on('auth', this.onAuth);
            window.bus.$on('update_global_search', function(search){
                self.search = search;
                window.bus.$emit('global_search', search);
            });

            if(localStorage.sponsor_uuid){
                this.sponsor_uuid = localStorage.sponsor_uuid;
            }

            //If url has sponsor save it to local storage in case user leaves without signing up
            var url = new URL(window.location.href);
            var sponsor_uuid = url.searchParams.get('sponsor_uuid');
            if(sponsor_uuid){
                localStorage.setItem('sponsor_uuid', sponsor_uuid);
                this.sponsor_uuid = sponsor_uuid;
            }

            setTimeout(function(){
                self.showEmailVerificationModal();
            }, 1000);
        },
        methods: {
            init: function(){
                if(this.user){
                    this.getInvitations();
                }
            },
            showEmailVerificationModal: function(){
                if(!this.user){
                    return;
                }
                //Only show modal if email is not verified or if user just verified it
                var url = new URL(window.location.href);
                var show_modal = url.searchParams.has('email_verified') || !this.user.email_verified_at;

                if(show_modal){
                    var route = window.route_name;
                    //Only show the modal in the following routes
                    var routes = ['home', 'how-it-works', 'pricing', 'contact', 'faq', 'search', 'settings'];
                    if(routes.includes(route)){
                        $('#emailVerificationModal').modal('show');
                    }
                    this.clearEmailVerifiedQueryString();
                }
            },
            clearEmailVerifiedQueryString: function(){
                // Get the current URL
                const url = new URL(window.location.href);

                const searchParams = new URLSearchParams(url.search);
                searchParams.delete('email_verified');
                url.search = searchParams.toString();

                // Replace the query string with the updated version
                history.replaceState(null, null, url);
            },
            onAuth: function(user){
                this.user = user;
            },
            loadGSIScript: function(){
                if(this.loaded_gsi_script){
                    return;
                }
                var self = this;
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.async = true;
                script.defer = true;
                script.onload = function(){
                    // remote script has loaded
                    self.loadRecaptchaScript();
                };
                script.src = 'https://accounts.google.com/gsi/client';
                document.head.appendChild(script);
                this.loaded_gsi_script = true;
            },
            showCreateAdModal: function(){
                $('#menuModal').modal('hide');
                $('#createAdModal').modal('show');
            },
            updateProfileImage: function (src) {
                $('#userProfileImage').attr('src', src);
            },
            getProfileUrl: function (object) {
                if (object.className === 'TG\\Models\\Meloquent\\Influencer') {
                    //Influencer object
                    if (object.slug) {
                        return '/influencer/' + object.slug;
                    }
                    if (object._social_accounts && object._social_accounts.length) {
                        var account = object._social_accounts[0];
                        if (account.source && account.username) {
                            return '/' + account.source + '/' + account.username;
                        }
                    }

                    return '/influencer/' + object.uuid;
                } else {
                    //Account object
                    var source = object.source;
                    var id = object.username || object.uuid;
                    return `/${source}/${id}`;
                }
            },
            initSearchSuggestions: function () {
//                this.getDefaultSuggestions();
            },
            redirectToSearch: function () {
                if(window.route_name === 'search'){
                    return;
                }
                var href = '/search';
//                var url_object = new URL(window.location.href);
//                var href = "http://"+url_object.hostname

                if (this.search) {
                    let query = encodeURIComponent(this.search.trim());
                    href += '?q=' + query;
                }
                //window.location.href = href;
                  window.open(href, "_self")
            },
            debouncedSearch: debounce(function () {
                window.bus.$emit('global_search', this.search);
//                this.getSearchSuggestions();
            }, 600),
            showSearch: function () {
                var self = this;
                this.show_search = true;
//                this.getDefaultSuggestions();
                Vue.nextTick(function () {
                    $('#headerSearchInput').focus();
                });
                // $("#main-wrapper").one("click", function() {
                //     self.hideSearch();
                // });
            },
            hideSearch: function () {
                this.show_search = false;
            },
            showRegisterModal: function () {
                $('#menuModal').modal('hide');
                if(!this.loaded_gsi_script) {
                    this.loadGSIScript();
                }
                this.is_login = false;
                this.showModal();
            },
            showLoginModal: function () {
                $('#menuModal').modal('hide');
                if(!this.loaded_gsi_script) {
                    this.loadGSIScript();
                }
                this.is_login = true;
                this.showModal();
            },
            showModal: function () {
                $('#authModal').modal('show');
            },
            loadRecaptchaScript: function () {
                if(this.loaded_recaptcha_script) {
                    return;
                }
                var self = this;
                var script = document.createElement('script');
                var site_key = $('#recaptchaV3SiteKey').val();
                var src = 'https://www.google.com/recaptcha/api.js?render=' + site_key;
                script.setAttribute('src', src);
                document.head.appendChild(script);
                this.loaded_recaptcha_script = true;
                script.onload = function () {
                    self.initRecaptcha();
                }
            },
            initRecaptcha: function () {
                var self = this;
                grecaptcha.ready(() => {
                    grecaptcha.render('recaptcha1', {
                        'sitekey': $('#recaptchaV2SiteKey').val(),
                        'callback': function (response) {
                            self.recaptcha_token = response;
                        },
                        'expired-callback': function (response) {
                            self.recaptcha_token = '';
                        },
                        'error-callback': function (response) {
                            self.recaptcha_token = '';
                        }
                    });
                });
            },
            submitForm: function (event) {
                var self = this;
                event.preventDefault();

                var scope = this.is_login ? 'login' : 'signup';
                self.$validator.validateAll(scope).then(function (is_valid) {

                    if (is_valid) {
                        self.loading.submit = true;
                        if (self.is_login) {
                            $('#loginForm').submit();
                        } else {
                            grecaptcha.execute($('#recaptchaV3SiteKey').val(), {action: 'signup'}).then(function (token) {
                                self.recaptcha_v3_token = token;
                                Vue.nextTick(function () {
                                    $('#signupForm').submit();
                                });
                            });
                        }

                        //Just in case user is not redirected on submission
                        setTimeout(function () {
                            self.loading.submit = true;
                        }, 5000);

                    }

                });

            },
            showMenu: function () {
                $('#menuModal').modal('show');
            },
            getSearchSuggestions: function () {
                var self = this;
                if (self.loading.suggestions) {
                    return;
                }
                self.loading.suggestions = true;
                var url = '/api/v4/search/suggestions';
                var params = {
                    search: this.search.trim()
                };
                axios.get(url, {params: params}).then(function (response) {
                    self.profiles = response.data.data.creators;
                    self.hashtags = response.data.data.hashtags;
                    self.loading.suggestions = false;
                }).catch(function (error) {
                    Raven.captureMessage(JSON.stringify(error));
                    self.loading.suggestions = false;
                });
            },
            getDefaultSuggestions: function () {
                var self = this;
                if (self.loaded_defaults || self.loading.default_suggestions) {
                    return;
                }
                self.loading.default_suggestions = true;
                var url = '/api/v4/search/suggestions/default';
                var params = {};
                axios.get(url, {params: params}).then(function (response) {
                    self.top_hashtags = response.data.data.top_hashtags;
                    self.recent_searches = response.data.data.recent_searches;
                    self.hashtags = response.data.data.hashtags;
                    self.profiles = response.data.data.profiles;
                    self.loading.default_suggestions = false;
                    self.loaded_defaults = true;
                }).catch(function (error) {
                    Raven.captureMessage(JSON.stringify(error));
                    self.loading.default_suggestions = false;
                });
            },
            toggleTheme: function(){
                var themes = ['dark', 'light'];
                var current_theme = document.documentElement.getAttribute('data-theme') || 'light';
                this.current_theme = current_theme;
                
                var i = 0;
                for(i=0; i < themes.length; i++){
                    var theme = themes[i];
                    if(current_theme === theme){
                        break;
                    }
                }
                i++;
                var next_theme_index = i % themes.length;
                var next_theme = themes[next_theme_index];
                document.documentElement.setAttribute('data-theme', next_theme);
                
                this.current_theme = next_theme;
                if(next_theme){
                    localStorage.setItem('theme', next_theme);
                } else {
                    localStorage.removeItem('theme');
                }
                window.bus.$emit('theme-changed', next_theme);
            },
            initIntersection: function(el, cb){
                if(!el){
                    return;
                }
                var self = this;
                if(!this.io){
                    this.io = new IntersectionObserver(entries => {
                        entries.forEach(function(entry) {
                            if(entry.isIntersecting){
                                let target = entry.target;
                                if(!target.__loaded && target.__cb){
                                    target.__cb();
                                    target.__loaded = true;
                                    self.io.unobserve(target);
                                }
                            }
                        });
                    }, {});
                }

                el.__loaded = false;
                el.__cb = cb;
                this.io.observe(el);
            },
            getInvitations: function () {
                var self = this;
                if (self.loading.invitations) {
                    return;
                }
                self.loading.invitations = true;
                var url = '/api/v5/user/invitations';
                var params = {};
                axios.get(url, {params: params}).then(function (response) {
                    var data = response.data.data;
                    self.invitation_count = data.length;
                    self.loading.invitations = false;
                }).catch(function (error) {
                    Raven.captureMessage(JSON.stringify(error));
                    self.loading.invitations = false;
                });
            },
        },
        filters: {

        },

    };
</script>



// WEBPACK FOOTER //
// resources/views/rd/assets/js/v2/components/mainHeading.vue